module.exports = __webpack_public_path__ + "media/images/flags/NO-3848377ece8d4fdf3b7abbeffef7aa8c.svg";